module.exports = __webpack_public_path__ + "static/media/top-section.11318461.png";